import * as React from 'react';
import Form, { FormComponentProps } from 'antd/lib/form';
import styled from 'styled-components';
import FormControl from '../../Forms/FormControl';


export const StyleRegisterForm = styled(Form)`
  max-width: 1100px;
  min-width: 300px;

  .login-form-forgot {
    float: right;
  }

  .login-form-button {
    background-color: rgb(174, 24, 87);
    float: right;
  }

  .cancel-form-button {    
    float: right;
    color: #F0403D;
    border-color: #F0403D;
  }

  .register-form-button {
    background-color: #F0403D;
    border-color: #F0403D;
    
  }

  .cancel-form-button {
  }

`;
